/**
 * Smooth scroll for anchor links
 */
jQuery(document).ready(function ($) {
    // Handle clicks on anchor links
    $('a[href^="#"]').on("click", function (e) {
        const href = $(this).attr("href");

        // Skip if href is just "#" or empty
        if (!href || href === "#") {
            return;
        }

        // Find target element
        const $target = $(href);

        if ($target.length) {
            e.preventDefault();

            // Smooth scroll to target
            $("html, body").animate(
                {
                    scrollTop: $target.offset().top,
                },
                400,
                "swing"
            );

            // Update URL hash without jumping
            if (history.pushState) {
                history.pushState(null, null, href);
            } else {
                // Fallback for older browsers
                location.hash = href;
            }
        }
    });
});

/**
 * Accordion functionality for FAQ page
 */

class Accordion {
    constructor() {
        this.triggers = document.querySelectorAll("[data-accordion-trigger]");
        this.init();
    }

    init() {
        if (this.triggers.length === 0) return;

        this.triggers.forEach((trigger) => {
            trigger.addEventListener("click", this.handleClick.bind(this));
        });

        // Close all accordions on page load
        this.closeAll();
    }

    handleClick(event) {
        const trigger = event.currentTarget;
        const item = trigger.closest(".faq-accordion__item");
        const content = trigger.nextElementSibling;
        const isOpen = item.classList.contains("is-open");

        if (isOpen) {
            this.closeItem(item, trigger, content);
        } else {
            this.openItem(item, trigger, content);
        }
    }

    openItem(item, trigger, content) {
        // Close other open items in the same accordion
        const accordion = item.closest(".faq-accordion");
        const openItems = accordion.querySelectorAll(".faq-accordion__item.is-open");

        openItems.forEach((openItem) => {
            if (openItem !== item) {
                const openTrigger = openItem.querySelector("[data-accordion-trigger]");
                const openContent = openItem.querySelector("[data-accordion-content]");
                this.closeItem(openItem, openTrigger, openContent);
            }
        });

        // Open the clicked item
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");

        // Set max-height for smooth animation
        const scrollHeight = content.scrollHeight;
        content.style.maxHeight = scrollHeight + "px";

        // Reset max-height after animation completes
        setTimeout(() => {
            if (item.classList.contains("is-open")) {
                content.style.maxHeight = "none";
            }
        }, 300);
    }

    closeItem(item, trigger, content) {
        // Set specific max-height before closing for smooth animation
        const scrollHeight = content.scrollHeight;
        content.style.maxHeight = scrollHeight + "px";

        // Force reflow
        content.offsetHeight;

        // Close the item
        item.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
        content.style.maxHeight = "0px";
    }

    closeAll() {
        this.triggers.forEach((trigger) => {
            const item = trigger.closest(".faq-accordion__item");
            const content = trigger.nextElementSibling;

            item.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");
            content.setAttribute("aria-hidden", "true");
            content.style.maxHeight = "0px";
        });
    }

    openAll() {
        this.triggers.forEach((trigger) => {
            const item = trigger.closest(".faq-accordion__item");
            const content = trigger.nextElementSibling;

            this.openItem(item, trigger, content);
        });
    }
}

// Initialize accordion when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
    new Accordion();
});

// Export for use in other modules if needed
export default Accordion;

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Housing plans image switching functionality.
     * Switches corresponding images when housing plans tabs are clicked.
     */
    const housingPlansSection = document.querySelector(".housing-plans");

    // Function to show corresponding image based on tab
    function switchHousingPlanImage(activeTab, imageContainer) {
        const containerId = activeTab.getAttribute("data-container_id");

        // Extract the number from container ID (e.g., "container-1" -> "1")
        const containerNumber = containerId ? containerId.replace("container-", "") : null;

        if (containerNumber) {
            const planImages = imageContainer.querySelectorAll(".housing-plans__img");

            // Hide all images
            planImages.forEach((img) => {
                img.style.display = "none";
            });

            // Show the corresponding image
            const targetImage = imageContainer.querySelector(
                `[data-image_count="${containerNumber}"]`
            );
            if (targetImage) {
                targetImage.style.display = "block";
            }
        }
    }

    if (housingPlansSection) {
        const tabsContainer = housingPlansSection.querySelector(".tabs");
        const imageContainer = housingPlansSection.querySelector(".housing-plans__img-wrap");

        if (tabsContainer && imageContainer) {
            const tabItems = tabsContainer.querySelectorAll(".tabs__item");

            // Add click event listeners to tab items
            tabItems.forEach((tab) => {
                tab.addEventListener("click", function () {
                    // Use setTimeout to ensure the tab becomes active first
                    setTimeout(() => {
                        if (tab.classList.contains("tabs__item--active")) {
                            switchHousingPlanImage(tab, imageContainer);
                        }
                    }, 10);
                });
            });

            // Handle initial state - show image for active tab
            const activeTab = tabsContainer.querySelector(".tabs__item--active");
            if (activeTab) {
                switchHousingPlanImage(activeTab, imageContainer);
            }
        }
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".faq-accordion").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".faq-page__title, .faq-section__title, .faq-accordion__item").each(
            function (index, element) {
                gsap.fromTo(
                    element,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 1,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 90%",
                            toggleActions: "play none none none",
                        },
                    }
                );
            }
        );
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    // Check if section exists on page
    if ($(".advantages").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".advantages__row--first",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".advantages__row--first",
                    start: "top 80%",
                    toggleActions: "play none none none",
                },
            }
        );

        gsap.fromTo(
            ".advantages__image",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".advantages__image",
                    start: "top 60%",
                    toggleActions: "play none none none",
                },
            }
        );

        $(".advantages__item").each(function (index, element) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 60%",
                    toggleActions: "play none none none",
                },
            });

            tl.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 0.3,
                    scale: 1.2,
                    ease: "power2.out",
                    delay: index * 0.15,
                }
            ).to(element, {
                duration: 0.5,
                scale: 1,
                ease: "linear",
            });
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".breadcrumbs").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        animateBreadcrumbs();
    }
});

function animateBreadcrumbs() {
    jQuery(".breadcrumbs").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                delay: 0.5,
                ease: "power2.out",
            }
        );
    });
}

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".city-living-section").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".city-living-section__title",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 0.5,
            }
        );

        gsap.fromTo(
            ".city-living-section__subtitle",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1,
            }
        );

        gsap.fromTo(
            ".city-living-section__col .btn",
            {
                duration: 1,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1.5,
            }
        );
    }
});

/**
 * Map component using Google Maps JavaScript API with AdvancedMarkerElement on
 * Contacts page.
 *
 * @package BRMJ\Components
 */
function initMap() {
    if (!window.brmj_map_data || !window.brmj_map_data.lat || !window.brmj_map_data.lng) {
        return;
    }

    const map = new google.maps.Map(document.getElementById("contacts-map"), {
        zoom: 15,
        mapId: "contacts-map", // Required for AdvancedMarkerElement
        styles: [
            {
                featureType: "all",
                elementType: "geometry.fill",
                stylers: [{ color: "#f5f5f5" }],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [{ color: "#c9c9c9" }],
            },
        ],
    });

    // Geocoder for converting address to coordinates
    const geocoder = new google.maps.Geocoder();

    // Geocoding the address
    geocoder.geocode(
        {
            location: {
                lat: parseFloat(window.brmj_map_data.lat),
                lng: parseFloat(window.brmj_map_data.lng),
            }, // Рига, Латвія
        },
        (results, status) => {
            if (status === "OK") {
                // Set map center
                map.setCenter(results[0].geometry.location);

                // Create custom marker element (HTML-based)
                const markerContent = document.createElement("div");
                markerContent.innerHTML = `
                <div style="width: 75px; height: 75px; background-image: url('/wp-content/themes/brauerei-majas/assets/img/map-marker.svg'); background-size: contain; background-repeat: no-repeat;"></div>
            `;

                // Create new AdvancedMarkerElement
                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: results[0].geometry.location,
                    content: markerContent,
                    title: "Brauerei Mājas",
                });

                // Info window
                const infoWindow = new google.maps.InfoWindow({
                    content: `
                    <div style="padding: 0 15px 15px 15px; max-width: 250px;">
                        <h3 style="margin: 0 0 10px 0; color: #1a2b42; font-size: 16px;">Brauerei Mājas</h3>
                        <p style="margin: 0; color: #1a2b42; font-size: 14px;">${results[0].formatted_address}</p>
                        <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(results[0].formatted_address)}" 
                           target="_blank" 
                           style="display: inline-block; margin-top: 10px; color: #007cba; text-decoration: none; font-size: 14px;">
                           Get directions →
                        </a>
                    </div>
                `,
                });

                // Open info window on marker click
                marker.addListener("click", () => {
                    infoWindow.open({
                        anchor: marker,
                        map: map,
                    });
                });
            } else {
                console.error("Geocode was not successful for the following reason: " + status); // eslint-disable-line no-console
            }
        }
    );
}

window.initMap = initMap;

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".contacts").length) {
        animateContactsBlock();

        // Re-animate contacts when a tab is activated on single project pages
        $(document).on("tabActivated", function () {
            if ($("body.single-project").length) {
                animateContactsBlock();
            }
        });
    }
});

function animateContactsBlock() {
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    jQuery(".contacts").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 60%",
                    toggleActions: "play none none none",
                },
            }
        );
    });
}

/**
 * Init select2.
 */
jQuery(function ($) {
    orderbyInitSelect2();
    $(document).on("ready", orderbyInitSelect2);

    function orderbyInitSelect2() {
        $(".wpc-orderby-select").select2({
            minimumResultsForSearch: Infinity,
            templateSelection: function (data) {
                if (!data.id) return data.text;

                let prefix = $(data.element).data("prefix") || "";
                return $("<span>").html(
                    prefix + " " + "<span class='filter-option'>" + data.text + "</span>"
                );
            },
        });
    }
});

/**
 * JavaScript for the filter on the Archive page.
 *
 * @package BRMJ
 */
jQuery(function ($) {
    if ($("body.archive").length) {
        let $filterSetId = $(".wpc-filters-main-wrap").attr("data-set");
        $(".archive-filter__front .wpc-filter-chips-list").attr("data-set", $filterSetId);

        let frontButtonsSelector = ".archive-filter__front .wpc-filter-chips-list button";
        let resetAllButtonSelector = ".archive-filter__front .wpc-filter-chips-list .reset-all";

        // Check for status query parameter and activate corresponding button
        let checkStatusParam = function () {
            const urlParams = new URLSearchParams(window.location.search);
            const status = urlParams.get("status");

            if (status) {
                $(document)
                    .find(frontButtonsSelector)
                    .each(function () {
                        let $this = $(this);
                        let $buttonSlug = $this.attr("data-slug");

                        if ($buttonSlug === status) {
                            $(document)
                                .find(frontButtonsSelector)
                                .removeClass("archive-filter__button--active");
                            $(document)
                                .find(resetAllButtonSelector)
                                .removeClass("archive-filter__button--active");
                            $this.addClass("archive-filter__button--active");
                            return false; // Break out of the loop
                        }
                    });
            } else {
                // If no status parameter, activate reset-all button
                $(document)
                    .find(frontButtonsSelector)
                    .removeClass("archive-filter__button--active");
                $(document).find(resetAllButtonSelector).addClass("archive-filter__button--active");
            }
        };

        // Execute on page load
        checkStatusParam();
        $(document).on("ready", function () {
            $filterSetId = $(".wpc-filters-main-wrap").attr("data-set");
            $(".archive-filter__front .wpc-filter-chips-list").attr("data-set", $filterSetId);
            checkStatusParam();
        });

        // Reset all front buttons on click reset all.
        $(document).on("click", resetAllButtonSelector, function (e) {
            e.preventDefault();
            $(document).find(frontButtonsSelector).removeClass("archive-filter__button--active");
            $(this).addClass("archive-filter__button--active");
        });

        // Init buttons.
        $(document)
            .find(frontButtonsSelector)
            .each(function () {
                let $this = $(this);
                let $frontButtonSlug = $this.attr("data-slug");
                let disabled = true;
                let filterButtons = $(document).find(
                    ".wpc-filters-main-wrap .wpc-radio-item label .wpc-filter-link"
                );

                filterButtons.each(function () {
                    let $that = $(this);
                    let $filterButtonSlug = $that.text().toLowerCase().replace(/\s+/g, "-");

                    if ($frontButtonSlug === $filterButtonSlug) {
                        disabled = false;
                    }
                });

                if (disabled) {
                    $this.prop("disabled", true);
                }
            });

        // Choose filter term on click front button.
        $(document).on("click", frontButtonsSelector, function (e) {
            e.preventDefault();
            let $this = $(this);

            if ($this.prop("disabled") || $this.hasClass("archive-filter__button--active")) {
                return;
            }

            $(document).find(frontButtonsSelector).removeClass("archive-filter__button--active");
            $(document).find(resetAllButtonSelector).removeClass("archive-filter__button--active");
            $this.addClass("archive-filter__button--active");

            let $frontButtonSlug = $this.attr("data-slug");
            let filterButtons = $(document).find(
                ".wpc-filters-main-wrap .wpc-radio-item label .wpc-filter-link"
            );

            filterButtons.each(function () {
                let $that = $(this);
                let $filterButtonSlug = $that.text().toLowerCase().replace(/\s+/g, "-");
                let input = $that.closest(".wpc-term-item-content-wrapper").find("input");

                if ($frontButtonSlug === $filterButtonSlug) {
                    input[0].click();
                    return false;
                }
            });
        });
    }
});

/**
 * Houses List block functionality.
 */
class HousesList {
    constructor() {
        this.columnsConfig = {
            columns: null, // Order of columns
            labels: {}, // Custom labels for columns
            visible: null, // Which columns to show
            widths: {}, // Custom widths for columns
        };

        this.init();
    }

    init() {
        // Configure table columns
        this.setColumnsConfig({
            columns: [
                "house_number",
                "status",
                "first_floor_area",
                "second_floor_area",
                "total_floors_area",
                "roof_terrace_area",
                "total_usable_area",
                "price",
                "sellable_area",
                "price_per_sqm",
            ],
        });

        this.initComponents();
        this.bindEvents();
    }

    initComponents() {
        // Initialize Select2 for sort dropdown
        jQuery("#houses-sort").select2({
            minimumResultsForSearch: Infinity,
            templateSelection: function (data) {
                if (!data.id) return data.text;

                let prefix = jQuery(data.element).data("prefix") || "";
                return jQuery("<span>").html(
                    prefix + " " + "<span class='filter-option'>" + data.text + "</span>"
                );
            },
        });
    }

    bindEvents() {
        // Handle sort dropdown change
        jQuery("#houses-sort").on("select2:select", (e) => {
            this.handleSortChange(e.target);
        });

        // Load initial table if container exists
        const container = document.querySelector(".houses-list__content");
        if (container) {
            this.loadTable();
        }
    }

    handleSortChange(selectElement) {
        const sortBy = selectElement.value;
        this.loadTable(sortBy);
    }

    /**
     * Set columns configuration
     */
    setColumnsConfig(config) {
        if (config.columns) {
            this.columnsConfig.columns = config.columns;
        }
        if (config.labels) {
            this.columnsConfig.labels = { ...this.columnsConfig.labels, ...config.labels };
        }
        if (config.visible) {
            this.columnsConfig.visible = config.visible;
        }
        if (config.widths) {
            this.columnsConfig.widths = { ...this.columnsConfig.widths, ...config.widths };
        }
    }

    /**
     * Get available columns configuration from server
     */
    loadAvailableColumns() {
        return jQuery.ajax({
            url: window.brmjAjax ? window.brmjAjax.ajaxUrl : "/wp-admin/admin-ajax.php",
            type: "POST",
            data: {
                action: "brmj_get_available_columns",
                nonce: window.brmjAjax ? window.brmjAjax.nonce : "",
            },
        });
    }

    /**
     * Reset columns configuration
     */
    resetColumnsConfig() {
        this.columnsConfig = {
            columns: null,
            labels: {},
            visible: null,
            widths: {},
        };
    }

    /**
     * Check if columns configuration is set
     */
    hasColumnsConfig() {
        return (
            this.columnsConfig.columns !== null ||
            Object.keys(this.columnsConfig.labels).length > 0 ||
            this.columnsConfig.visible !== null ||
            Object.keys(this.columnsConfig.widths).length > 0
        );
    }

    loadTable(sortBy = "newest") {
        const container = document.querySelector(".houses-list__content");
        if (!container) return;

        // Show loading state
        this.showLoading(container);

        // Get configuration from data attributes or defaults
        const projectId = container.dataset.projectId || "";
        const currentHouseId = container.dataset.currentHouseId || "";
        const columns = container.dataset.columns ? container.dataset.columns.split(",") : [];

        // Prepare AJAX data
        const ajaxData = {
            action: "brmj_get_houses",
            nonce: window.brmjAjax ? window.brmjAjax.nonce : "",
            sort_by: sortBy,
        };

        // Add optional parameters
        if (projectId) {
            ajaxData.project_id = projectId;
        }

        if (currentHouseId) {
            ajaxData.current_house_id = currentHouseId;
        }

        if (columns.length > 0) {
            ajaxData.columns = columns;
        }

        // Add columns configuration if available
        if (this.hasColumnsConfig()) {
            ajaxData.columns_config = this.columnsConfig;
        }

        // Make AJAX request
        jQuery.ajax({
            url: window.brmjAjax ? window.brmjAjax.ajaxUrl : "/wp-admin/admin-ajax.php",
            type: "POST",
            data: ajaxData,
            success: (response) => {
                if (response.success && response.data.html) {
                    container.innerHTML = response.data.html;
                } else {
                    this.showError(
                        container,
                        window.brmjAjax.polylang.strings.houses_list_js.failed_to_load
                    );
                }
            },
            error: () => {
                this.showError(
                    container,
                    window.brmjAjax.polylang.strings.houses_list_js.loading_table_error
                );
            },
        });
    }

    showLoading(container) {
        container.innerHTML = '<div class="houses-table-loading"></div>';
    }

    showError(container, message) {
        container.innerHTML = `<div class="houses-table-error">${message}</div>`;
    }
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", () => {
    new HousesList();
});

/**
 * Image slider initialization.
 */
jQuery(function ($) {
    // Check if image slider exists on page
    if ($(".hs-gallery__slider").length) {
        const splide = new Splide(".hs-gallery__slider", {
            type: "slide",
            perPage: 3,
            gap: "24px",
            pagination: false,
            arrows: false,
            speed: 650,
            rewindSpeed: 650,
            breakpoints: {
                1200: {
                    perPage: 3,
                    gap: "24px",
                },
                768: {
                    perPage: 3,
                    gap: "16px",
                },
                575: {
                    perPage: 1,
                    gap: "8px",
                },
            },
        }).mount();

        // Custom navigation buttons
        const prevBtn = $(".hs-gallery__nav-btn--prev");
        const nextBtn = $(".hs-gallery__nav-btn--next");

        // Function to update button states
        const updateButtonStates = function () {
            const currentIndex = splide.index;
            const slideCount = splide.length;

            // Disable prev button if at first slide
            if (currentIndex === 0) {
                prevBtn.addClass("disabled").attr("disabled", true);
            } else {
                prevBtn.removeClass("disabled").attr("disabled", false);
            }

            // Disable next button if at last slide
            if (
                ($(window).outerWidth() >= 576 && slideCount - currentIndex <= 3) ||
                ($(window).outerWidth() < 576 && slideCount - currentIndex <= 1)
            ) {
                nextBtn.addClass("disabled").attr("disabled", true);
            } else {
                nextBtn.removeClass("disabled").attr("disabled", false);
            }
        };

        // Update button states on slide change
        splide.on("moved", updateButtonStates);

        // Initial button state update
        updateButtonStates();

        prevBtn.on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                splide.go("<");
            }
        });

        nextBtn.on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                splide.go(">");
            }
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".houses-list").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        let element = ".houses-list__header";
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                stagger: 0.2,
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none",
                },
            }
        );
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".housing-plans").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        let element = ".housing-plans__wrap";
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none",
                },
            }
        );
    }
});

/**
 * Image slider initialization.
 */
jQuery(function ($) {
    // Check if image slider exists on page
    if ($(".hs-gallery__slider").length) {
        const splide = new Splide(".hs-gallery__slider", {
            type: "slide",
            perPage: 3,
            gap: "24px",
            pagination: false,
            arrows: false,
            speed: 650,
            rewindSpeed: 650,
            breakpoints: {
                1200: {
                    perPage: 3,
                    gap: "24px",
                },
                768: {
                    perPage: 3,
                    gap: "16px",
                },
                575: {
                    perPage: 1,
                    gap: "8px",
                },
            },
        }).mount();

        // Custom navigation buttons
        const prevBtn = $(".hs-gallery__nav-btn--prev");
        const nextBtn = $(".hs-gallery__nav-btn--next");

        // Function to update button states
        const updateButtonStates = function () {
            const currentIndex = splide.index;
            const slideCount = splide.length;

            // Disable prev button if at first slide
            if (currentIndex === 0) {
                prevBtn.addClass("disabled").attr("disabled", true);
            } else {
                prevBtn.removeClass("disabled").attr("disabled", false);
            }

            // Disable next button if at last slide
            if (
                ($(window).outerWidth() >= 576 && slideCount - currentIndex <= 3) ||
                ($(window).outerWidth() < 576 && slideCount - currentIndex <= 1)
            ) {
                nextBtn.addClass("disabled").attr("disabled", true);
            } else {
                nextBtn.removeClass("disabled").attr("disabled", false);
            }
        };

        // Update button states on slide change
        splide.on("moved", updateButtonStates);

        // Initial button state update
        updateButtonStates();

        prevBtn.on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                splide.go("<");
            }
        });

        nextBtn.on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("disabled")) {
                splide.go(">");
            }
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".hs-gallery:not(.animation-off)").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        let element = ".hs-gallery__header";
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none",
                },
            }
        );

        element = ".hs-gallery__img-wrap";
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                stagger: 0.2,
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none",
                },
            }
        );
    }
});

/**
 * Image slider initialization.
 */
jQuery(function ($) {
    // Check if image slider exists on page
    if ($(".image-slider").length) {
        new Splide(".image-slider", {
            type: "loop",
            perPage: 1,
            focus: "center",
            gap: "8px",
            pagination: false,
            arrows: false,
            speed: 650,
            rewindSpeed: 650,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            fixedWidth: "711px",
            // Keep neighbors visible on narrow screens too
            padding: { left: "10%", right: "10%" },
            breakpoints: {
                768: {
                    padding: { left: "8%", right: "8%" },
                    fixedWidth: false,
                },
                640: {
                    padding: { left: "6%", right: "6%" },
                    fixedWidth: false,
                },
                480: {
                    padding: { left: "4%", right: "4%" },
                    fixedWidth: false,
                },
            },
        }).mount();
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".image-slider").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".image-slider").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Init select2.
 */
jQuery(function ($) {
    $("#lang_choice_1").select2({
        minimumResultsForSearch: Infinity,
    });

    $("#lang_choice_1").on("change", function (event) {
        location.href = event.currentTarget.value;
    });
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".news").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".news__header").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "linear",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });

        $(".news-card__link").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "linear",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Toggle active state of visualization spots on click.
 */
jQuery(function ($) {
    if ($(".project-visualization").length) {
        const CARD_HALF_GAP = 10;
        const CARD_DEFAULT_OFFSET_Y = 30;

        const resetCardPosition = ($card) => {
            $card.css({
                top: `calc(50% + ${CARD_DEFAULT_OFFSET_Y}px)`,
                left: "50%",
            });
        };

        const keepCardInBounds = ($spot) => {
            const $container = $spot.closest(".project-visualization");
            const $card = $spot.find(".project-visualization__card").first();

            if (!$container.length || !$card.length) {
                return;
            }

            resetCardPosition($card);

            if (
                !$spot.hasClass("project-visualization__spot--active") ||
                window.innerWidth <= 768
            ) {
                return;
            }

            const containerRect = $container[0].getBoundingClientRect();
            const cardRect = $card[0].getBoundingClientRect();

            const overflowLeft = Math.max(0, containerRect.left - cardRect.left + CARD_HALF_GAP);
            const overflowTop = Math.max(0, containerRect.top - cardRect.top + CARD_HALF_GAP);
            const overflowRight = Math.max(0, cardRect.right - containerRect.right + CARD_HALF_GAP);
            const overflowBottom = Math.max(
                0,
                cardRect.bottom - containerRect.bottom + CARD_HALF_GAP
            );

            if (!overflowLeft && !overflowTop && !overflowRight && !overflowBottom) {
                return;
            }

            const currentLeft = $card[0].offsetLeft;
            const currentTop = $card[0].offsetTop;

            const nextLeft = currentLeft + overflowLeft - overflowRight;
            const nextTop = currentTop + overflowTop - overflowBottom;

            $card.css({
                left: `${nextLeft}px`,
                top: `${nextTop}px`,
            });
        };

        $(".project-visualization__spot").on("click", function (e) {
            if (window.innerWidth > 768) {
                e.stopPropagation();
                $(this).toggleClass("project-visualization__spot--active");
                $(".project-visualization__spot")
                    .not(this)
                    .removeClass("project-visualization__spot--active");

                $(".project-visualization__spot")
                    .not(this)
                    .find(".project-visualization__card")
                    .each(function () {
                        resetCardPosition($(this));
                    });

                keepCardInBounds($(this));
            } else {
                window.location.href = $(this).data("href");
            }
        });

        $(".project-visualization__card").on("click", function (e) {
            e.stopPropagation();
        });

        $(".project-visualization,.project-visualization__image").on("click", function () {
            $(".project-visualization__spot").removeClass("project-visualization__spot--active");
            $(".project-visualization__card").each(function () {
                resetCardPosition($(this));
            });
        });

        let resizeTimeout;

        $(window).on("resize", function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                $(".project-visualization__spot--active").each(function () {
                    keepCardInBounds($(this));
                });
            }, 50);
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".projects").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".projects__header").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });

        $(".project-card__link").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    delay: index * 0.2,
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Map component using Google Maps JavaScript API with AdvancedMarkerElement and
 * Places API for nearby places on Single Project page.
 *
 * @package BRMJ\Components
 */

class ProjectMap {
    constructor() {
        this.map = null;
        this.mainMarker = null;
        this.placeMarkers = [];
        this.infoWindow = null;
        this.geocoder = null;
        this.distanceService = null;
        this.placesService = null;
        this.currentCategory = "rest"; // Default category
        this.activeMarker = null; // Track currently active marker
        this.visitedMarkers = new Set(); // Track visited markers

        this.init();
    }

    init() {
        // Check if map data is available
        if (!window.brmj_project_map_data) {
            // eslint-disable-next-line no-console
            console.error("Project map data not found");
            return;
        }

        this.initMap();
        this.bindEvents();
    }

    initMap() {
        // Get main address from data
        const mainAddress = window.brmj_project_map_data.main_address || "Rīga, Latvia";

        // Initialize map
        this.map = new google.maps.Map(document.getElementById("single-project-map"), {
            zoom: 14,
            mapId: "single-project-map", // Required for AdvancedMarkerElement
            styles: [
                {
                    featureType: "all",
                    elementType: "geometry.fill",
                    stylers: [{ color: "#f5f5f5" }],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{ color: "#c9c9c9" }],
                },
            ],
        });

        // Initialize geocoder, distance service, and places service
        this.geocoder = new google.maps.Geocoder();
        this.distanceService = new google.maps.DistanceMatrixService();
        this.placesService = new google.maps.places.PlacesService(this.map);

        // Initialize info window
        this.infoWindow = new google.maps.InfoWindow();

        // Add event listener for info window close
        this.infoWindow.addListener("closeclick", () => {
            this.resetActiveMarker();
        });

        // Add click listener to map to reset active marker when clicking outside markers
        this.map.addListener("click", () => {
            this.resetActiveMarker();
            this.infoWindow.close();
        });

        // Prefer coordinates from data, fallback to geocoding by address
        const lat = Number(window.brmj_project_map_data.lat);
        const lng = Number(window.brmj_project_map_data.lng);
        const hasValidCoords =
            Number.isFinite(lat) &&
            Number.isFinite(lng) &&
            lat >= -90 &&
            lat <= 90 &&
            lng >= -180 &&
            lng <= 180;

        if (hasValidCoords) {
            const position = { lat: lat, lng: lng };

            // Set map center
            this.map.setCenter(position);

            // Create main marker
            this.createMainMarker(position, mainAddress);

            // Load places for default category
            this.loadNearbyPlaces(this.currentCategory);
            return;
        }
    }

    createMainMarker(position, address) {
        const projectTitle = window.brmj_project_map_data.project_title || "";

        // Create custom main marker element
        const markerContent = document.createElement("div");
        markerContent.innerHTML = `
            <div style="width: 75px; height: 75px; background-image: url('/wp-content/themes/brauerei-majas/assets/img/map-marker.svg'); background-size: contain; background-repeat: no-repeat;"></div>
        `;

        // Create main marker
        this.mainMarker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: position,
            content: markerContent,
            title: "Brauerei Mājas - Main Location",
        });

        // Add click event for main marker
        this.mainMarker.addListener("click", (event) => {
            // Stop event propagation to prevent map click event
            event.stop();

            // Reset any active marker before opening main marker info
            this.resetActiveMarker();

            this.infoWindow.setContent(`
                <div style="padding: 0 15px 15px 15px; max-width: 250px;">
                    <h3 style="margin: 0 0 10px 0; color: #1a2b42; font-size: 16px;">${projectTitle}</h3>
                    <p style="margin: 0; color: #1a2b42; font-size: 14px;">${address}</p>
                    <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}" 
                       target="_blank" 
                       style="display: inline-block; margin-top: 10px; color: #007cba; text-decoration: none; font-size: 14px;">
                       Get directions →
                    </a>
                </div>
            `);
            this.infoWindow.open({
                anchor: this.mainMarker,
                map: this.map,
            });
        });
    }

    loadNearbyPlaces(category) {
        // Reset active marker when loading new places
        this.resetActiveMarker();

        // Clear existing place markers
        this.clearPlaceMarkers();

        // Get category data
        const categoryData = window.brmj_project_map_data.categories[category];
        if (!categoryData || !categoryData.place_types) {
            return;
        }

        // Get search radius from data (default 5000 meters)
        const radius = window.brmj_project_map_data.search_radius || 5000;

        // Search for places for each type in the category
        categoryData.place_types.forEach((placeType) => {
            this.searchPlacesByType(placeType, radius);
        });
    }

    searchPlacesByType(placeType, radius) {
        if (!this.mainMarker) {
            return;
        }

        const request = {
            location: this.mainMarker.position,
            radius: radius,
            type: placeType,
        };

        this.placesService.nearbySearch(request, (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                results.forEach((place) => {
                    this.createPlaceMarker(place);
                });
            } else {
                // eslint-disable-next-line no-console
                console.warn(`Places search failed for type ${placeType}: ${status}`);
            }
        });
    }

    createPlaceMarker(place) {
        if (!place.geometry || !place.geometry.location) {
            return;
        }

        // Create place marker (circle with number)
        const markerContent = document.createElement("div");
        markerContent.innerHTML = `
            <div class="marker-circle" style="
                width: 24px; 
                height: 24px; 
                background-color: #42608A; 
                border-radius: 50%; 
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: 12px;
                font-weight: bold;
                transition: all 0.3s ease;
            "></div>
        `;

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: place.geometry.location,
            content: markerContent,
            title: place.name,
        });

        // Store reference to marker content for color changes
        marker.markerElement = markerContent.querySelector(".marker-circle");

        // Add click event to show place info and calculate walking time
        marker.addListener("click", (event) => {
            // Stop event propagation to prevent map click event
            event.stop();
            this.showPlaceInfo(place, marker);
        });

        this.placeMarkers.push(marker);
    }

    infoWindowContent(placeName, distanceText, showDistancePlaceholder = true) {
        let distanceClassHelper = showDistancePlaceholder
            ? "marker-info-window__distance--placeholder"
            : "";

        return `
            <div class="marker-info-window" >

                <div class="marker-info-window__header" >
                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C6 0.89545 6.8954 0 8 0C9.1046 0 10 0.89545 10 2C10 3.10455 9.1046 4 8 4C6.8954 4 6 3.10455 6 2Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6001 14.2001C6.0419 14.5314 6.1314 15.1582 5.8001 15.6001L2.80006 19.6001C2.46869 20.0419 1.84189 20.1314 1.40006 19.8001C0.958229 19.4687 0.868689 18.8419 1.20006 18.4001L4.20006 14.4001C4.53143 13.9582 5.1582 13.8687 5.6001 14.2001Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.16441 5.01376C7.70921 5.10456 8.07721 5.61978 7.98641 6.16456L7.07101 11.6569L9.70711 14.293C9.78311 14.3691 9.84641 14.4568 9.89441 14.5529L11.8944 18.5529C12.1414 19.0469 11.9412 19.6476 11.4472 19.8946C10.9532 20.1416 10.3526 19.9413 10.1056 19.4474L8.17821 15.5925L5.29291 12.7073C5.06451 12.4789 4.96054 12.1543 5.01361 11.8358L6.01361 5.83576C6.10441 5.29099 6.61961 4.92297 7.16441 5.01376Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.7576 5.02988C7.0983 4.94468 7.4588 5.04453 7.7072 5.29291L10.5403 8.126L13.3163 9.0513C13.8403 9.226 14.1234 9.7923 13.9488 10.3162C13.7741 10.8402 13.2078 11.1234 12.6839 10.9487L9.6839 9.9487C9.5366 9.8996 9.4028 9.8169 9.293 9.7071L6.6934 7.10749L3.61771 7.8764L1.83216 10.5547C1.5258 11.0142 0.90493 11.1384 0.44541 10.8321C-0.0141204 10.5257 -0.1383 9.9048 0.16806 9.4453L2.16806 6.44532C2.30605 6.23834 2.51623 6.09021 2.75757 6.02988L6.7576 5.02988Z" fill="black"/>
                    </svg>

                    <h6 class="marker-info-window__distance  ${distanceClassHelper}" >${distanceText}</h6>
                </div>
                <p class="marker-info-window__body">${placeName}</p>

            </div>
        `;
    }

    showPlaceInfo(place, marker) {
        if (!this.mainMarker) {
            return;
        }

        // Reset previous active marker
        this.resetActiveMarker();

        // Set current marker as active and change its color
        this.activeMarker = marker;
        this.setMarkerActive(marker);

        // Mark this marker as visited
        this.visitedMarkers.add(marker);

        // Show loading state
        this.infoWindow.setContent(
            this.infoWindowContent(
                place.name,
                window.brmj_project_map_data.distance_statuses.calculating
            )
        );
        this.infoWindow.open({
            anchor: marker,
            map: this.map,
        });

        // Calculate distance and time
        this.distanceService.getDistanceMatrix(
            {
                origins: [this.mainMarker.position],
                destinations: [place.geometry.location],
                travelMode: google.maps.TravelMode.WALKING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            },
            (response, status) => {
                if (status === "OK" && response.rows[0].elements[0].status === "OK") {
                    const element = response.rows[0].elements[0];
                    const duration = element.duration.text;

                    this.infoWindow.setContent(this.infoWindowContent(place.name, duration, false));
                } else {
                    this.infoWindow.setContent(
                        this.infoWindowContent(
                            place.name,
                            window.brmj_project_map_data.distance_statuses.unavailable
                        )
                    );
                }
            }
        );
    }

    clearPlaceMarkers() {
        this.placeMarkers.forEach((marker) => {
            marker.map = null;
        });
        this.placeMarkers = [];
        // Clear visited markers when changing categories
        this.visitedMarkers.clear();
    }

    /**
     * Set marker as active (change color to indicate selection)
     */
    setMarkerActive(marker) {
        if (marker && marker.markerElement) {
            marker.markerElement.style.backgroundColor = "#1A2B42";

            // Add white circle inside active marker
            if (!marker.markerElement.querySelector(".active-indicator")) {
                const activeIndicator = document.createElement("div");
                activeIndicator.className = "active-indicator";
                activeIndicator.style.cssText = `
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 10px;
                    height: 10px;
                    background-color: white;
                    border-radius: 50%;
                    pointer-events: none;
                `;
                marker.markerElement.style.position = "relative";
                marker.markerElement.appendChild(activeIndicator);
            }
        }
    }

    /**
     * Reset marker to default state
     */
    setMarkerInactive(marker) {
        if (marker && marker.markerElement) {
            // Remove white circle indicator
            const activeIndicator = marker.markerElement.querySelector(".active-indicator");
            if (activeIndicator) {
                activeIndicator.remove();
            }

            // Check if marker was visited - if so, keep the visited color
            if (this.visitedMarkers.has(marker)) {
                marker.markerElement.style.backgroundColor = "#1A2B42"; // Visited color
            } else {
                marker.markerElement.style.backgroundColor = "#42608A"; // Default blue color
            }
        }
    }

    /**
     * Reset the currently active marker to inactive state
     */
    resetActiveMarker() {
        if (this.activeMarker) {
            this.setMarkerInactive(this.activeMarker);
            this.activeMarker = null;
        }
    }

    bindEvents() {
        // Bind category buttons
        const categoryButtons = document.querySelectorAll(".project-map-category-btn");
        categoryButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                // Update active button
                categoryButtons.forEach((btn) => btn.classList.remove("active"));
                button.classList.add("active");

                // Get category from data attribute
                const category = button.getAttribute("data-category");
                if (category && category !== this.currentCategory) {
                    this.currentCategory = category;
                    this.loadNearbyPlaces(category);

                    // Smooth scroll to map
                    this.scrollToMap();
                }
            });
        });
    }

    /**
     * Smooth scroll to the map container
     */
    scrollToMap() {
        const mapContainer = document.getElementById("single-project-map");
        if (mapContainer) {
            mapContainer.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
            });
        }
    }
}

// Initialize map when Google Maps API is loaded
function initProjectMap() {
    if (document.getElementById("single-project-map")) {
        new ProjectMap();
    }
}

// Export for global access
window.initProjectMap = initProjectMap;

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".single-project-map").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".project-map-category-btn").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });

        $(".single-project-map__container").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 85%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Stats Section Animation
 * Animates counter numbers when they come into view
 */

class StatsAnimation {
    constructor() {
        this.statsSection = document.querySelector(".stats-section");
        this.isAnimated = false;

        if (this.statsSection) {
            this.init();
        }
    }

    init() {
        this.observeSection();
    }

    observeSection() {
        const options = {
            threshold: 0.3,
            rootMargin: "0px 0px -100px 0px",
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.isAnimated) {
                    this.animateStats();
                    this.isAnimated = true;
                }
            });
        }, options);

        observer.observe(this.statsSection);
    }

    animateStats() {
        const statItems = this.statsSection.querySelectorAll(".stats-section__col");

        statItems.forEach((item, index) => {
            setTimeout(() => {
                this.animateStatItem(item);
            }, index * 200); // Stagger animation by 200ms
        });
    }

    animateStatItem(item) {
        const valueElement = item.querySelector(".stats-section__value");
        const titleElement = item.querySelector(".stats-section__title");

        if (!valueElement) return;

        // Get the final number (handle decimal numbers with dots and spaces)
        const finalText = valueElement.textContent.trim();

        // Extract number with optional decimal part (handles spaces around)
        const numberMatch = finalText.match(/(\d+(?:\.\d+)?)/);
        const numberString = numberMatch ? numberMatch[1] : "0";
        const finalNumber = parseFloat(numberString);

        // Get everything after the number as suffix (preserving spacing)
        const numberEndIndex = finalText.indexOf(numberString) + numberString.length;
        const suffix = finalText.substring(numberEndIndex);

        // Determine decimal places from the original number string
        const dotIndex = numberString.indexOf(".");
        const decimalPlaces = dotIndex !== -1 ? numberString.length - dotIndex - 1 : 0;

        // Start animation
        valueElement.classList.add("animate");
        if (titleElement) {
            titleElement.classList.add("animate");
        }

        // Animate the number counting
        this.animateCounter(valueElement, 0, finalNumber, suffix, 2000, decimalPlaces);
    }

    animateCounter(element, start, end, suffix, duration, decimalPlaces = 0) {
        const increment = end / (duration / 16); // 60 FPS
        let current = start;

        const timer = setInterval(() => {
            current += increment;

            if (current >= end) {
                current = end;
                clearInterval(timer);
                element.classList.remove("counting");
            } else {
                element.classList.add("counting");
            }

            // Format number with appropriate decimal places
            let displayValue;
            if (decimalPlaces === 0) {
                displayValue = Math.round(current).toString();
            } else {
                displayValue = current.toFixed(decimalPlaces);
            }

            element.textContent = displayValue + suffix;
        }, 16); // ~60 FPS
    }

    // Method to reset animation (useful for testing)
    reset() {
        this.isAnimated = false;
        const statItems = this.statsSection.querySelectorAll(".stats-section__col");

        statItems.forEach((item) => {
            const valueElement = item.querySelector(".stats-section__value");
            const titleElement = item.querySelector(".stats-section__title");

            if (valueElement) {
                valueElement.classList.remove("animate", "counting");
            }
            if (titleElement) {
                titleElement.classList.remove("animate");
            }
        });
    }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
    new StatsAnimation();
});

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Tabs handler.
     */
    if (document.querySelector(".tabs") != null) {
        // Select all tab blocks on the page.
        const tabsBlocks = document.querySelectorAll(".tabs");

        tabsBlocks.forEach((block) => {
            // Select only direct child tab headers and tab content containers within this block
            // This prevents interference with nested tab blocks
            const tabNavigation = block.querySelector(":scope > .tabs__nav");
            const tabContent = block.querySelector(":scope > .tabs__content");

            if (!tabNavigation || !tabContent) return;

            const tabItems = tabNavigation.querySelectorAll(".tabs__item");
            const tabContainers = tabContent.querySelectorAll(":scope > .tabs__container");

            // Add ID attributes to tab items if they don't have them
            tabItems.forEach((tab, index) => {
                if (!tab.id) {
                    const containerId = tab.getAttribute("data-container_id");
                    tab.id = containerId ? `tab-${containerId}` : `tab-${index}`;
                }
            });

            // Function to activate a specific tab
            function activateTab(tab) {
                // Remove active class from all tabs and containers in this specific block only
                tabItems.forEach((t) => t.classList.remove("tabs__item--active"));
                tabContainers.forEach((c) => c.classList.remove("tabs__container--active"));

                // Add active class to the clicked tab
                tab.classList.add("tabs__item--active");

                // Get the corresponding container ID from data attribute
                const targetId = tab.getAttribute("data-container_id");
                const targetContainer = tabContent.querySelector(`#${targetId}`);

                // Activate the target container if it exists
                if (targetContainer) {
                    targetContainer.classList.add("tabs__container--active");

                    // Smooth scroll to the target container only if .tabs--no-scroll class is not present
                    if (!block.classList.contains("tabs--no-scroll")) {
                        targetContainer.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }

                    // Trigger a custom event when tab is activated
                    const tabActivatedEvent = new CustomEvent("tabActivated", {
                        detail: {
                            tab: tab,
                            container: targetContainer,
                            tabId: tab.id,
                            containerId: targetId,
                        },
                    });
                    document.dispatchEvent(tabActivatedEvent);
                }
            }

            // Check URL hash and activate corresponding tab
            function checkHashAndActivateTab() {
                const hash = window.location.hash.substring(1); // Remove # from hash
                if (hash) {
                    const targetTab = block.querySelector(`#${hash}`);
                    if (targetTab && targetTab.classList.contains("tabs__item")) {
                        activateTab(targetTab);
                    }
                }
            }

            // Activate tab on initial load
            checkHashAndActivateTab();

            // Listen for hash changes
            window.addEventListener("hashchange", checkHashAndActivateTab);

            tabItems.forEach((tab) => {
                tab.addEventListener("click", function () {
                    activateTab(tab);

                    // Update URL hash when tab is clicked
                    if (tab.id) {
                        history.pushState(null, null, `#${tab.id}`);
                    }
                });
            });
        });
    }
});

/**
 * Testimonials slider initialization.
 */
jQuery(function ($) {
    // Check if testimonials slider exists on page
    if ($(".testimonials__slider").length) {
        new Splide(".testimonials__slider", {
            // Show 1 card centered; neighbors peek in thanks to padding on .splide
            type: "loop",
            perPage: 1,
            focus: "center",
            gap: "176px",
            pagination: false,
            arrows: false,
            speed: 650,
            rewindSpeed: 650,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            fixedWidth: "648px",
            // Keep neighbors visible on narrow screens too
            padding: { left: "10%", right: "10%" },
            breakpoints: {
                768: {
                    padding: { left: "8%", right: "8%" },
                    gap: "80px",
                    fixedWidth: false,
                },
                640: {
                    padding: { left: "6%", right: "6%" },
                    gap: "60px",
                    fixedWidth: false,
                },
                480: {
                    padding: { left: "4%", right: "4%" },
                    gap: "40px",
                    fixedWidth: false,
                },
            },
        }).mount();
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".testimonials").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".testimonials").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 60%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    // Check if section exists on page
    if ($(".text-and-image").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".text-and-image__title",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".text-and-image__title",
                    start: "top 80%",
                    toggleActions: "play none none none",
                },
            }
        );

        gsap.fromTo(
            ".text-and-image__image-wrap",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".text-and-image__image-wrap",
                    start: "top 60%",
                    toggleActions: "play none none none",
                },
            }
        );

        $(".text-and-image__text-block").each(function (index, element) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 60%",
                    toggleActions: "play none none none",
                },
            });

            tl.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    delay: index * 0.15,
                }
            );
        });
    }
});

/**
 * Play video on click.
 */
jQuery(function ($) {
    const $wrap = $("#hero-video");
    const $poster = $wrap.find(".video-card__poster");
    const $btn = $wrap.find(".video-card__play");
    const $iframe = $(".video-card__iframe");

    $(document).on("click", ".video-card__poster, .video-card__play", function () {
        // Add autoplay and playsinline parameters to the iframe URL
        // to enable autoplay on mobile devices.
        const url = new URL($iframe.attr("src"));
        url.searchParams.set("autoplay", "1");
        url.searchParams.set("playsinline", "1");
        $iframe.attr("src", url.toString());

        $btn.fadeOut();
        $poster.animate({ opacity: 0 }, 300, function () {});

        $iframe.animate({ opacity: 1 }, 300, function () {
            $iframe.css("z-index", "7");
        });

        $wrap.addClass("video-card__wrap--is-playing");
        $iframe.attr("tabindex", "-1").trigger("focus");
    });
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".video-section").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".video-section .container",
            {
                duration: 1,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 2,
            }
        );
    }
});

jQuery(document).ready(function ($) {
    const params = new URLSearchParams(window.location.search);

    if (params.get("rrtv_g") !== "1") {
        return;
    }

    if (!params.get("r")) {
        console.log("No 'r' parameter provided.");
        return;
    }

    if (!params.get("a")) {
        console.log("No 'a' parameter provided.");
        return;
    }

    $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
            action: "rrtv_g",
            r: params.get("r") || "",
            a: params.get("a") || "",
        },
        success: function (response) {
            console.log(response.data);
        },
    });
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($(".footer").length) {
        animateFooter();

        // Re-animate footer when a tab is activated on single project pages
        $(document).on("tabActivated", function () {
            if ($("body.single-project").length) {
                animateFooter();
            }
        });
    }
});

function animateFooter() {
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    jQuery(".footer__section:not(.footer__section--three)").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    });
}

/**
 * Gallery Lightbox
 *
 * @description: Custom GLightbox implementation for gallery layout.
 * @see: https://biati-digital.github.io/glightbox/
 */
jQuery(function ($) {
    const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
        <div class="gloader visible"></div>
        <div class="goverlay"></div>
        <div class="gcontainer">
            <div class="gslider-container">
                <div id="glightbox-slider" class="gslider"></div>
                
                <div class="glightbox-thumbnails"></div>

                <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><svg viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.25 0.75L19 4.5M19 4.5L15.25 8.25M19 4.5H1" stroke="#101823" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>

                <button class="gprev gbtn" tabindex="1" aria-label="Previous"><svg viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.75 8.25L1 4.5M1 4.5L4.75 0.75M1 4.5H19" stroke="#101823" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
            </div>

            <button class="gclose gbtn" tabindex="2" aria-label="Close"><svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1M1 1L13 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>
        </div>
    </div>`;

    let customSlideHTML = `<div class="gslide">
        <div class="gslide-inner-content">
            <div class="ginner-container">
                <div class="gslide-media">
                </div>
                <div class="gslide-description">
                    <div class="gdesc-inner">
                        <h4 class="gslide-title"></h4>
                        <div class="gslide-desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;

    const glightbox = GLightbox({
        selector: "[data-glightbox]",
        zoomable: false,
        closeOnOutsideClick: false,
        lightboxHTML: customLightboxHTML,
        slideHTML: customSlideHTML,
        skin: "custom",
    });

    // Filter out clone elements after GLightbox initialization
    if (glightbox.elements) {
        glightbox.elements = glightbox.elements.filter((el) => {
            // Skip cloned elements by checking if the element or its parent has clone class
            const isClone =
                el.node &&
                (el.node.closest(".splide__slide--clone") ||
                    el.node.classList.contains("splide__slide--clone"));
            return !isClone;
        });
    }

    glightbox.on("open", function () {
        // Create thumbnails in the lightbox, filtering out clones.
        let $thumbsHtml = "";
        const uniqueElements = [];
        const seenUrls = new Set();

        // Filter out duplicate elements (clones)
        glightbox.elements.forEach(function (el, originalIndex) {
            // Skip cloned elements by checking if the parent has clone class
            const isClone =
                el.node &&
                (el.node.closest(".splide__slide--clone") ||
                    el.node.classList.contains("splide__slide--clone"));

            if (!isClone && !seenUrls.has(el.href)) {
                seenUrls.add(el.href);
                uniqueElements.push({ ...el, originalIndex });
            }
        });

        uniqueElements.forEach(function (el) {
            let sizes = "";
            if (el.sizes) {
                sizes = "sizes='" + el.sizes + "'";
            }

            let srcset = "";
            if (el.srcset) {
                srcset = "sizes='" + el.srcset + "'";
            }

            let activeClass = "";
            // Check if this element corresponds to the active slide
            const currentActiveIndex = glightbox.getActiveSlideIndex();
            const currentActiveElement = glightbox.elements[currentActiveIndex];
            if (currentActiveElement && el.href === currentActiveElement.href) {
                activeClass = "glightbox-thumbnails__item--active";
            }

            $thumbsHtml +=
                "<div class='glightbox-thumbnails__item " +
                activeClass +
                "' data-index='" +
                el.originalIndex +
                "'><img class='glightbox-thumbnails__item-image' src='" +
                el.href +
                "' alt ='" +
                el.alt +
                "' " +
                srcset +
                " " +
                sizes +
                " /></div>";
        });

        const $thumbnailsContainer = $(glightbox.activeSlide)
            .closest(".gcontainer")
            .find(".glightbox-thumbnails");

        $thumbnailsContainer.html($thumbsHtml);

        // Immediately scroll to active thumbnail without animation
        const currentIndex = glightbox.getActiveSlideIndex();
        const $activeThumb = $thumbnailsContainer.find(`[data-index="${currentIndex}"]`);

        if ($activeThumb.length && $thumbnailsContainer.length) {
            const containerWidth = $thumbnailsContainer.outerWidth();
            const thumbPosition = $activeThumb.position().left;
            const thumbWidth = $activeThumb.outerWidth();
            const scrollTo = thumbPosition - (containerWidth - thumbWidth) / 2;

            // Set scroll position immediately without animation
            $thumbnailsContainer.scrollLeft(Math.max(0, scrollTo));
        }

        // Show thumbnails with animation after positioning
        $thumbnailsContainer.animate({ opacity: 1 }, 700);

        // Initialize drag functionality after thumbnails are created
        initThumbnailsDrag($thumbnailsContainer);

        // Add click event to thumbnails.
        $(glightbox.activeSlide)
            .closest(".gcontainer")
            .find(".glightbox-thumbnails__item")
            .on("click", function (e) {
                // Check if this was a drag operation
                const $container = $(this).closest(".glightbox-thumbnails");
                if ($container.data("isDragging")) {
                    e.preventDefault();
                    return;
                }

                e.preventDefault();
                let index = parseInt($(this).attr("data-index"), 10);

                $(this)
                    .addClass("glightbox-thumbnails__item--active")
                    .siblings()
                    .removeClass("glightbox-thumbnails__item--active");
                glightbox.goToSlide(index);
            });
    });

    // Listen for slide changes to update active thumbnail and auto-scroll
    glightbox.on("slide_changed", function ({ current }) {
        const currentIndex = current.slideIndex;
        const currentElement = glightbox.elements[currentIndex];
        const $thumbnailsContainer = $(glightbox.activeSlide)
            .closest(".gcontainer")
            .find(".glightbox-thumbnails");

        // Update active thumbnail - find by matching href instead of index
        $thumbnailsContainer
            .find(".glightbox-thumbnails__item")
            .removeClass("glightbox-thumbnails__item--active");

        // Find the thumbnail that matches the current slide's href
        let $activeThumb = null;
        $thumbnailsContainer.find(".glightbox-thumbnails__item").each(function () {
            const thumbIndex = parseInt($(this).attr("data-index"), 10);
            const thumbElement = glightbox.elements[thumbIndex];
            if (thumbElement && thumbElement.href === currentElement.href) {
                $activeThumb = $(this).addClass("glightbox-thumbnails__item--active");
                return false; // Break the loop
            }
        });

        if (!$activeThumb) {
            // Fallback to index-based matching if href matching fails
            $activeThumb = $thumbnailsContainer
                .find(`[data-index="${currentIndex}"]`)
                .addClass("glightbox-thumbnails__item--active");
        }

        // Auto-scroll to active thumbnail if it exists
        if ($activeThumb.length && $thumbnailsContainer.length) {
            const containerWidth = $thumbnailsContainer.outerWidth();
            const containerScrollLeft = $thumbnailsContainer.scrollLeft();
            const thumbPosition = $activeThumb.position().left;
            const thumbWidth = $activeThumb.outerWidth();

            // Calculate if thumbnail is visible in the container
            const thumbLeftEdge = thumbPosition + containerScrollLeft;
            const thumbRightEdge = thumbLeftEdge + thumbWidth;
            const containerLeftEdge = containerScrollLeft;
            const containerRightEdge = containerScrollLeft + containerWidth;

            // Scroll if thumbnail is not fully visible
            if (thumbLeftEdge < containerLeftEdge || thumbRightEdge > containerRightEdge) {
                const scrollTo = thumbLeftEdge - (containerWidth - thumbWidth) / 2;
                $thumbnailsContainer.animate(
                    {
                        scrollLeft: Math.max(0, scrollTo),
                    },
                    300
                );
            }
        }

        // Initialize drag functionality for thumbnails
        initThumbnailsDrag($thumbnailsContainer);
    });

    // Function to initialize drag functionality for thumbnails
    function initThumbnailsDrag($container) {
        if (!$container.length) return;

        // Check if container has scrollable content
        const hasScrollbar = $container[0].scrollWidth > $container[0].clientWidth;
        if (!hasScrollbar) {
            $container
                .removeClass("glightbox-thumbnails--draggable")
                .addClass("glightbox-thumbnails--no-draggable")
                .css("cursor", "default");
            return;
        }

        let isDragging = false;
        let hasDragged = false;
        let startX = 0;
        let scrollLeft = 0;
        let momentum = 0;
        let lastX = 0;
        let lastTime = 0;
        let animationId = null;

        // Remove any existing drag event listeners to avoid duplicates
        $container.off(".thumbnailDrag");

        // Add smooth CSS transition for when not dragging
        $container.addClass("glightbox-thumbnails--draggable").css({
            "scroll-behavior": "auto",
            transition: "none",
        });

        $container.on("mousedown.thumbnailDrag", function (e) {
            // Only drag with left mouse button
            if (e.which !== 1) return;

            isDragging = true;
            hasDragged = false;
            startX = e.pageX;
            lastX = e.pageX;
            lastTime = Date.now();
            scrollLeft = $container.scrollLeft();
            momentum = 0;

            // Cancel any existing momentum animation
            if (animationId) {
                cancelAnimationFrame(animationId);
                animationId = null;
            }

            // Mark container as potentially dragging
            $container.data("isDragging", false);

            // Add cursor style and prevent text selection
            $container.find(".glightbox-thumbnails__item").css({
                cursor: "grabbing",
                "user-select": "none",
                "-webkit-user-select": "none",
                "-moz-user-select": "none",
                "-ms-user-select": "none",
            });

            // Prevent default behavior
            e.preventDefault();
        });

        $(document).on("mousemove.thumbnailDrag", function (e) {
            if (!isDragging) return;

            const x = e.pageX;
            const distance = Math.abs(x - startX);
            const currentTime = Date.now();

            // If moved more than 3 pixels, consider it a drag (reduced threshold for smoother response)
            if (distance > 3) {
                hasDragged = true;
                $container.data("isDragging", true);
            }

            if (hasDragged) {
                e.preventDefault();

                // Calculate momentum for smoother movement
                const deltaTime = currentTime - lastTime;
                if (deltaTime > 0) {
                    momentum = (x - lastX) / deltaTime;
                }

                const walk = (x - startX) * 1.2; // Reduced multiplier for smoother movement
                const newScrollLeft = scrollLeft - walk;

                // Smooth scrolling with bounds checking
                const maxScroll = $container[0].scrollWidth - $container[0].clientWidth;
                const boundedScroll = Math.max(0, Math.min(maxScroll, newScrollLeft));

                // Use requestAnimationFrame for smoother scrolling
                if (animationId) {
                    cancelAnimationFrame(animationId);
                }

                animationId = requestAnimationFrame(function () {
                    $container.scrollLeft(boundedScroll);
                });

                lastX = x;
                lastTime = currentTime;
            }
        });

        // Function to apply momentum after drag ends
        function applyMomentum() {
            if (Math.abs(momentum) < 0.1) return;

            const currentScroll = $container.scrollLeft();
            const maxScroll = $container[0].scrollWidth - $container[0].clientWidth;

            // Calculate new scroll position with momentum
            const newScroll = currentScroll - momentum * 15; // Momentum factor
            const boundedScroll = Math.max(0, Math.min(maxScroll, newScroll));

            // Apply easing to momentum
            momentum *= 0.95;

            // Smooth scroll to new position
            animationId = requestAnimationFrame(function () {
                $container.scrollLeft(boundedScroll);

                // Continue momentum if still significant
                if (Math.abs(momentum) > 0.1) {
                    applyMomentum();
                }
            });
        }

        $(document).on("mouseup.thumbnailDrag", function () {
            if (isDragging) {
                isDragging = false;

                // Apply momentum for smooth deceleration
                if (hasDragged && Math.abs(momentum) > 0.5) {
                    applyMomentum();
                }

                // Reset cursor and enable pointer events
                $container.find(".glightbox-thumbnails__item").css({
                    cursor: "grab",
                    "user-select": "",
                    "-webkit-user-select": "",
                    "-moz-user-select": "",
                    "-ms-user-select": "",
                });

                // Clear dragging flag after a short delay to allow click events
                setTimeout(function () {
                    $container.data("isDragging", false);
                }, 100); // Increased delay for momentum
            }
        });

        // Handle mouse leave to stop dragging
        $container.on("mouseleave.thumbnailDrag", function () {
            if (isDragging) {
                isDragging = false;

                // Apply momentum for smooth deceleration
                if (hasDragged && Math.abs(momentum) > 0.5) {
                    applyMomentum();
                }

                $container.find(".glightbox-thumbnails__item").css({
                    cursor: "grab",
                    "user-select": "",
                    "-webkit-user-select": "",
                    "-moz-user-select": "",
                    "-ms-user-select": "",
                });

                setTimeout(function () {
                    $container.data("isDragging", false);
                }, 100);
            }
        });

        // Add initial grab cursor when hovering over container
        $container.find(".glightbox-thumbnails__item").css("cursor", "grab");
    }

    $(document).on("click", ".gclose, .goverlay", function () {
        if ($(this).hasClass("goverlay") && !glightbox.settings.closeOnOutsideClick) {
            glightbox.close();
        }

        $(glightbox.activeSlide)
            .closest(".gcontainer")
            .find(".glightbox-thumbnails")
            .css("display", "none");

        // Clean up drag event listeners and animations
        $(document).off(".thumbnailDrag");

        // Cancel any running animations
        const $container = $(glightbox.activeSlide)
            .closest(".gcontainer")
            .find(".glightbox-thumbnails");
        if ($container.data("animationId")) {
            cancelAnimationFrame($container.data("animationId"));
        }
    });
});

/**
 * Header menu JS.
 */
jQuery(function ($) {
    const slideDuration = 300;
    const closeSiblings = true;

    // --- Utils ---
    // Collapse entire menu tree (all open submenus)
    function collapseAllSubmenus() {
        $(".nav-menu .menu-item-has-children.is-open").each(function () {
            const $li = $(this);
            const $sub = $li.children(".sub-menu");

            // Close direct submenu with animation
            $sub.stop(true, true).slideUp(slideDuration).attr("aria-hidden", "true");

            // Instantly close all nested submenus and markers
            $li.find(".menu-item-has-children")
                .removeClass("is-open")
                .children(".sub-menu")
                .stop(true, true)
                .hide() // no animation for deep descendants
                .attr("aria-hidden", "true");

            // ARIA
            $li.find("> a, > button").first().attr("aria-expanded", "false");
            $li.find(".menu-item-has-children > a, .menu-item-has-children > button").attr(
                "aria-expanded",
                "false"
            );
            $li.removeClass("is-open");
        });
    }

    // Collapse a single branch (current item + all its descendants)
    function collapseBranch($li) {
        const $sub = $li.children(".sub-menu");

        // Close direct submenu with animation
        $sub.stop(true, true).slideUp(slideDuration).attr("aria-hidden", "true");

        // Instantly close deeper levels
        $li.find(".menu-item-has-children")
            .removeClass("is-open")
            .children(".sub-menu")
            .stop(true, true)
            .hide()
            .attr("aria-hidden", "true");

        // ARIA
        $li.children("a, button").first().attr("aria-expanded", "false");
        $li.find(".menu-item-has-children > a, .menu-item-has-children > button").attr(
            "aria-expanded",
            "false"
        );

        $li.removeClass("is-open");
    }

    // --- Mobile burger toggle ---
    $(".header__mobile-menu-toggle").on("click", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $nav = $(".nav-menu");

        $("body").toggleClass("primary-menu-opened");
        $btn.toggleClass("active");
        $nav.toggleClass("active");

        // If menu is being closed, collapse everything
        if (!$nav.hasClass("active")) {
            collapseAllSubmenus();
        }
    });

    // --- Init ARIA & hide submenus initially ---
    function initAria() {
        $(".header .nav-menu .menu-item-has-children").each(function () {
            const $li = $(this);
            const $sub = $li.children(".sub-menu");
            if (!$sub.length) return;

            if (window.matchMedia("(min-width: 993px)").matches) {
                // Desktop
                $sub.removeAttr("style").removeAttr("aria-hidden");
                $li.children("a, button")
                    .first()
                    .removeAttr("aria-expanded")
                    .removeAttr("aria-haspopup");
            } else {
                // Mobile
                $sub.hide().attr("aria-hidden", "true");
                $li.children("a, button")
                    .first()
                    .attr({ "aria-expanded": "false", "aria-haspopup": "true" });
            }
        });
    }

    initAria();

    // Re-init on window resize (breakpoint crossing)
    $(window).on("resize", function () {
        initAria();
    });

    // --- Accordion behaviour ---
    // Click only on the direct anchor (prevents double-trigger)
    $(document).on(
        "click",
        "body.primary-menu-opened .header .nav-menu .menu-item-has-children > a",
        function (e) {
            // --- Toggle submenu ---
            const $trigger = $(this);
            const $li = $trigger.parent(".menu-item-has-children");
            const $sub = $li.children(".sub-menu");
            if (!$sub.length) return;

            const href = $trigger.attr("href");
            const isToggler = !href || href === "#" || $trigger.data("toggle") === "submenu";
            if (isToggler) e.preventDefault();
            e.stopPropagation(); // prevent bubbling

            const isOpen = $li.hasClass("is-open");

            // Close siblings first (classic accordion)
            if (closeSiblings) {
                $li.siblings(".menu-item-has-children.is-open").each(function () {
                    collapseBranch($(this));
                });
            }

            if (isOpen) {
                // Close current branch (and all descendants)
                collapseBranch($li);
            } else {
                // Open current submenu, ensure descendants are reset/hidden
                $li.addClass("is-open");
                $sub.stop(true, true).slideDown(slideDuration).attr("aria-hidden", "false");

                $trigger.attr("aria-expanded", "true");

                // Make sure any nested submenus start closed
                $li.find(".menu-item-has-children")
                    .removeClass("is-open")
                    .children(".sub-menu")
                    .hide()
                    .attr("aria-hidden", "true");
                $li.find(".menu-item-has-children > a, .menu-item-has-children > button").attr(
                    "aria-expanded",
                    "false"
                );
            }
        }
    );

    // Close menu.
    // Collapse everything on window resize if menu becomes desktop.
    $(window).on("resize", function () {
        if (window.matchMedia("(min-width: 993px)").matches) {
            $("body").removeClass("primary-menu-opened");
            $(".nav-menu, .header__mobile-menu-toggle").removeClass("active");
            collapseAllSubmenus();
        }
    });
});

/**
 * Add animation.
 */
jQuery(function ($) {
    // Check if section exists on page
    if ($(".header").length) {
        gsap.fromTo(
            ".header .container",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
            }
        );
    }
});

/**
 * Popup scripts.
 */
jQuery(function ($) {
    // Open
    $(document).on("click", 'a[href="#open-contacts-popup"]', function (e) {
        e.preventDefault();
        $("body").addClass("popup-contacts--open");
        $(".popup-contacts")
            .css("z-index", 99999999)
            .animate({ opacity: 1 }, 300, function () {});
    });

    // Close
    $(document).on("click", ".popup-contacts__close", function (e) {
        e.preventDefault();

        $(".popup-contacts").animate({ opacity: 0 }, 300, function () {
            $(this).css("z-index", "-1");
            $("body").removeClass("popup-contacts--open");
        });
    });
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.archive").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        animateArchiveContentParts();
    }
});

function animateArchiveContentParts() {
    gsap.fromTo(
        ".archive-header__title",
        {
            duration: 1,
            y: 50,
            opacity: 0,
            ease: "power2.out",
        },
        {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 0.5,
        }
    );

    gsap.fromTo(
        ".archive-header__subtitle",
        {
            duration: 1,
            y: 50,
            opacity: 0,
            ease: "power2.out",
        },
        {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1,
        }
    );

    gsap.fromTo(
        ".archive-filter",
        {
            duration: 1,
            opacity: 0,
            ease: "power2.out",
        },
        {
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 1.5,
        }
    );

    gsap.fromTo(
        ".archive-content__not-found",
        {
            duration: 1,
            opacity: 0,
            ease: "power2.out",
        },
        {
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            delay: 2,
        }
    );

    jQuery(".archive-pagination").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                },
            }
        );
    });
}

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.post-type-archive-project").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(document).on("ready", function () {
            jQuery(
                ".breadcrumbs, .archive-header__title, .archive-header__subtitle, .archive-filter, .project-card__link"
            ).css("opacity", 1);
        });

        $(".project-card__link:nth-child(1), .project-card__link:nth-child(2)").each(
            function (index, element) {
                gsap.fromTo(
                    element,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 1,
                        delay: 1 + index * 0.2,
                        ease: "linear",
                    }
                );
            }
        );

        $(".project-card__link:not(:nth-child(1)):not(:nth-child(2))").each(
            function (index, element) {
                gsap.fromTo(
                    element,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 1,
                        delay: index * 0.2,
                        ease: "linear",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 90%",
                            toggleActions: "play none none none",
                        },
                    }
                );
            }
        );
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.archive.category").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        animateNewsCards();
        $(document).on("ready", function () {
            jQuery(
                ".breadcrumbs, .archive-header__title, .archive-header__subtitle, .archive-filter, .news-card__link"
            ).css("opacity", 1);
        });
    }
});

function animateNewsCards() {
    jQuery(
        ".news-card__link:nth-child(1), .news-card__link:nth-child(2), .news-card__link:nth-child(3)"
    ).each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                delay: 1.8 + index * 0.2,
                ease: "linear",
            }
        );
    });

    jQuery(".news-card__link:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3))").each(
        function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "linear",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                }
            );
        }
    );
}

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.page-template-contacts").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".contacts-header__title",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 0.5,
            }
        );

        gsap.fromTo(
            ".contacts-header__subtitle",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1,
            }
        );

        $(".contacts-header__item").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2 + 1.5,
                    ease: "power2.out",
                }
            );
        });

        $(".company-details__item").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });

        $(".map-section").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.page-template-policies").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        $(".policies-page__sidebar ul > li").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: index * 0.2 + 0.5,
                    ease: "power2.out",
                }
            );
        });

        $(".policies-page__content-wrapper").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    delay: 1.2,
                    ease: "power2.out",
                }
            );
        });

        jQuery(
            ".policies-page__content h1, .policies-page__content h2, .policies-page__content h3, .policies-page__content h4, .policies-page__content h5, .policies-page__content h6, .policies-page__content p, .property-gallery, .post__thumbnail"
        ).each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "linear",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });

        jQuery(".policies-page__content li").each(function (index, element) {
            gsap.fromTo(
                element,
                {
                    opacity: 0,
                    y: 50,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.7,
                    delay: index * 0.1,
                    ease: "linear",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        toggleActions: "play none none none",
                    },
                }
            );
        });
    }
});

/**
 * Prices page functionality
 */
/* global noUiSlider */
class PricesPage {
    constructor() {
        this.projectSelect = null;
        this.areaSlider = null;
        this.currentFilters = {
            project_id: null,
            floors: [],
            rooms: [],
            area_min: null,
            area_max: null,
            exclude_reserved_and_sold: false,
        };

        this.columnsConfig = {
            columns: null, // Order of columns
            labels: {}, // Custom labels for columns
            visible: null, // Which columns to show
            widths: {}, // Custom widths for columns
        };

        this.init();
    }

    init() {
        if (!document.querySelector(".prices-page")) {
            return;
        }

        // Configure table columns
        this.setColumnsConfig({
            columns: [
                "house_number",
                "status",
                "number_of_floors",
                "number_of_rooms",
                "total_usable_area",
                "price_per_sqm",
                "price",
            ],
            labels: {
                number_of_floors: window.brmjAjax.polylang.strings.prices_js.number_of_floors_label,
                number_of_rooms: window.brmjAjax.polylang.strings.prices_js.number_of_rooms_label,
                total_usable_area:
                    window.brmjAjax.polylang.strings.prices_js.total_usable_area_label,
            },
        });

        this.initProjectSelect();
        this.initFilterButtons();
        this.initAreaSlider();
        this.initCheckbox();
        this.initResetButton();
    }

    /**
     * Initialize project Select2 dropdown
     */
    initProjectSelect() {
        const select = document.getElementById("project-select");
        if (!select) return;

        jQuery(select).select2({
            ajax: {
                type: "POST",
                url: window.brmjAjax.ajaxUrl,
                dataType: "json",
                delay: 250,
                data: (params) => {
                    return {
                        action: "brmj_search_projects",
                        nonce: window.brmjAjax.nonce,
                        q: params.term || "",
                        page: params.page || 1,
                    };
                },
                processResults: (data, params) => {
                    params.page = params.page || 1;

                    if (data.success) {
                        return {
                            results: data.data.results,
                            pagination: {
                                more: data.data.pagination.more,
                            },
                        };
                    }
                    return {
                        results: [],
                        pagination: {
                            more: false,
                        },
                    };
                },
                cache: true,
            },
            placeholder: select.dataset.placeholder,
            allowClear: true,
            minimumInputLength: 0,
            templateResult: this.formatProjectOption,
            templateSelection: this.formatProjectSelection,
        });

        // Handle project selection change
        jQuery(select).on("select2:select select2:clear", (e) => {
            const selectedValue = e.target.value;
            this.currentFilters.project_id = selectedValue || null;
            this.loadFilterOptions();
        });

        this.projectSelect = select;
    }

    /**
     * Format project option in dropdown
     */
    formatProjectOption(project) {
        if (project.loading) {
            return project.text;
        }

        return jQuery("<span>").text(project.text);
    }

    /**
     * Format selected project
     */
    formatProjectSelection(project) {
        return project.text || project.id;
    }

    /**
     * Initialize filter buttons (floors and rooms)
     */
    initFilterButtons() {
        document.addEventListener("click", (e) => {
            if (e.target.matches(".filter-button")) {
                e.preventDefault();
                this.toggleFilterButton(e.target);
            }
        });
    }

    /**
     * Toggle filter button state
     */
    toggleFilterButton(button) {
        const container = button.closest(".filter-buttons");
        const filterType = container.id.replace("-filter", "");
        const value = parseInt(button.dataset.value, 10);

        button.classList.toggle("active");

        // Update current filters
        if (button.classList.contains("active")) {
            if (!this.currentFilters[filterType].includes(value)) {
                this.currentFilters[filterType].push(value);
            }
        } else {
            this.currentFilters[filterType] = this.currentFilters[filterType].filter(
                (v) => v !== value
            );
        }

        this.loadTable();
    }

    /**
     * Initialize area range slider
     */
    initAreaSlider() {
        const sliderContainer = document.getElementById("area-slider");
        if (!sliderContainer) return;

        // Initialize slider with noUiSlider
        if (typeof noUiSlider !== "undefined") {
            noUiSlider.create(sliderContainer, {
                start: [0, 0],
                connect: true,
                range: {
                    min: 0,
                    max: 500,
                },
                step: 1,
                format: {
                    to: (value) => Math.round(value),
                    from: (value) => Number(value),
                },
            });

            sliderContainer.noUiSlider.on("update", (values) => {
                document.getElementById("area-min").textContent = values[0];
                document.getElementById("area-max").textContent = values[1];

                this.currentFilters.area_min = parseInt(values[0], 10);
                this.currentFilters.area_max = parseInt(values[1], 10);
            });

            sliderContainer.noUiSlider.on("change", () => {
                this.loadTable();
            });
        } else {
            // Fallback to simple range inputs if noUiSlider is not available
            this.initSimpleAreaInputs();
        }
    }

    /**
     * Fallback area inputs
     */
    initSimpleAreaInputs() {
        const container = document.querySelector(".area-slider-container");
        if (!container) return;

        container.innerHTML = `
            <div class="area-inputs">
                <input type="range" id="area-min-input" min="0" max="500" value="0" step="1">
                <input type="range" id="area-max-input" min="0" max="500" value="0" step="1">
            </div>
        `;

        const minInput = document.getElementById("area-min-input");
        const maxInput = document.getElementById("area-max-input");

        [minInput, maxInput].forEach((input) => {
            input.addEventListener("input", () => {
                const minVal = parseInt(minInput.value, 10);
                const maxVal = parseInt(maxInput.value, 10);

                if (minVal >= maxVal) {
                    if (input === minInput) {
                        maxInput.value = minVal + 5;
                    } else {
                        minInput.value = maxVal - 5;
                    }
                }

                document.getElementById("area-min").textContent = minInput.value;
                document.getElementById("area-max").textContent = maxInput.value;

                this.currentFilters.area_min = parseInt(minInput.value, 10);
                this.currentFilters.area_max = parseInt(maxInput.value, 10);
            });

            input.addEventListener("change", () => {
                this.loadTable();
            });
        });
    }

    /**
     * Initialize exclude checkbox
     */
    initCheckbox() {
        const checkbox = document.getElementById("exclude-reserved-and-sold");
        if (!checkbox) return;

        checkbox.addEventListener("change", (e) => {
            this.currentFilters.exclude_reserved_and_sold = e.target.checked;
            this.loadTable();
        });
    }

    /**
     * Initialize reset button
     */
    initResetButton() {
        const resetButton = document.getElementById("reset-filters");
        if (!resetButton) return;

        resetButton.addEventListener("click", () => {
            this.resetFilters();
            this.loadTable();
        });
    }

    /**
     * Reset all filters
     */
    resetFilters() {
        // Reset project select
        if (this.projectSelect) {
            jQuery(this.projectSelect).val(null).trigger("change");
        }

        // Reset filter buttons
        jQuery(".filter-button").remove();

        // Hide area slider container
        this.hideAreaSlider();

        // Reset area slider
        this.resetAreaSlider();

        // Reset checkbox
        const checkbox = document.getElementById("exclude-reserved-and-sold");
        if (checkbox) {
            checkbox.checked = false;
        }

        // Reset current filters
        this.currentFilters = {
            project_id: null,
            floors: [],
            rooms: [],
            area_min: null,
            area_max: null,
            exclude_reserved_and_sold: false,
        };
    }

    resetAreaSlider() {
        const sliderContainer = document.getElementById("area-slider");
        if (sliderContainer && sliderContainer.noUiSlider) {
            sliderContainer.noUiSlider.updateOptions({
                range: {
                    min: 0,
                    max: 0,
                },
            });

            sliderContainer.noUiSlider.set([0, 0]);
        }
    }

    /**
     * Load filter options based on selected project
     */
    loadFilterOptions() {
        if (!this.currentFilters.project_id) {
            this.clearDynamicFilters();
            this.loadTable();
            return;
        }

        this.hideAreaSlider();
        this.resetAreaSlider();
        this.clearTableContainer();
        this.showLoading();

        jQuery.ajax({
            url: window.brmjAjax.ajaxUrl,
            type: "POST",
            data: {
                action: "brmj_get_filter_options",
                nonce: window.brmjAjax.nonce,
                project_id: this.currentFilters.project_id,
            },
            success: (response) => {
                this.hideLoading();

                if (response.success) {
                    this.updateDynamicFilters(response.data);
                    this.loadTable();
                }
            },
            error: () => {
                this.hideLoading();
            },
        });
    }

    /**
     * Update dynamic filter options
     */
    updateDynamicFilters(data) {
        // Update floors filter
        this.updateFilterButtons("floors-filter", data.floors);

        // Update rooms filter
        this.updateFilterButtons("rooms-filter", data.rooms);

        // Show and update area slider range
        if (data.area_min !== null && data.area_max !== null) {
            this.showAreaSlider();
            this.updateAreaSlider(data.area_min, data.area_max);
        } else {
            this.hideAreaSlider();
        }
    }

    /**
     * Update filter buttons
     */
    updateFilterButtons(containerId, values) {
        const container = document.getElementById(containerId);
        if (!container) return;

        container.innerHTML = "";

        values.forEach((value) => {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "filter-button";
            button.dataset.value = value;
            button.textContent = value;
            container.appendChild(button);
        });
    }

    /**
     * Update area slider range
     */
    updateAreaSlider(minValue, maxValue) {
        const sliderContainer = document.getElementById("area-slider");

        if (sliderContainer && sliderContainer.noUiSlider) {
            // Update slider range
            sliderContainer.noUiSlider.updateOptions({
                range: {
                    min: minValue,
                    max: maxValue,
                },
            });

            // Set current values
            sliderContainer.noUiSlider.set([minValue, maxValue]);
        }

        // Update current filters
        this.currentFilters.area_min = minValue;
        this.currentFilters.area_max = maxValue;

        // Update display
        document.getElementById("area-min").textContent = minValue;
        document.getElementById("area-max").textContent = maxValue;
    }

    /**
     * Clear dynamic filters
     */
    clearDynamicFilters() {
        const floorsContainer = document.getElementById("floors-filter");
        const roomsContainer = document.getElementById("rooms-filter");

        if (floorsContainer) floorsContainer.innerHTML = "";
        if (roomsContainer) roomsContainer.innerHTML = "";

        // Hide area slider when no project is selected
        this.hideAreaSlider();
    }

    /**
     * Show area slider container
     */
    showAreaSlider() {
        const areaContainer = document.querySelector(".area-slider-container");
        if (areaContainer) {
            areaContainer.classList.add("visible");
        }
    }

    /**
     * Hide area slider container
     */
    hideAreaSlider() {
        const areaContainer = document.querySelector(".area-slider-container");
        if (areaContainer) {
            areaContainer.classList.remove("visible");
        }
    }

    /**
     * Load initial table
     */
    loadInitialTable() {
        this.loadTable();
    }

    /**
     * Set columns configuration
     */
    setColumnsConfig(config) {
        if (config.columns) {
            this.columnsConfig.columns = config.columns;
        }
        if (config.labels) {
            this.columnsConfig.labels = { ...this.columnsConfig.labels, ...config.labels };
        }
        if (config.visible) {
            this.columnsConfig.visible = config.visible;
        }
        if (config.widths) {
            this.columnsConfig.widths = { ...this.columnsConfig.widths, ...config.widths };
        }
    }

    /**
     * Get available columns configuration from server
     */
    loadAvailableColumns() {
        return jQuery.ajax({
            url: window.brmjAjax.ajaxUrl,
            type: "POST",
            data: {
                action: "brmj_get_available_columns",
                nonce: window.brmjAjax.nonce,
            },
        });
    }

    /**
     * Reset columns configuration
     */
    resetColumnsConfig() {
        this.columnsConfig = {
            columns: null,
            labels: {},
            visible: null,
            widths: {},
        };
    }

    /**
     * Load houses table
     */
    loadTable() {
        this.showLoading();
        this.clearTableContainer();

        const data = {
            action: "brmj_get_houses",
            nonce: window.brmjAjax.nonce,
            sort_by: "newest",
            ...this.currentFilters,
        };

        // Add columns configuration if available
        if (this.hasColumnsConfig()) {
            data.columns_config = this.columnsConfig;
        }

        jQuery.ajax({
            url: window.brmjAjax.ajaxUrl,
            type: "POST",
            data: data,
            success: (response) => {
                if (response.success) {
                    jQuery("#houses-table-container").html(response.data.html).addClass("loaded");

                    // Smooth scroll to table after loading
                    if (jQuery(window).outerWidth() <= 992) {
                        this.scrollToTable();
                    }
                }

                this.hideLoading();
            },
            error: () => {
                this.hideLoading();
            },
        });
    }

    /**
     * Check if columns configuration is set
     */
    hasColumnsConfig() {
        return (
            this.columnsConfig.columns !== null ||
            Object.keys(this.columnsConfig.labels).length > 0 ||
            this.columnsConfig.visible !== null ||
            Object.keys(this.columnsConfig.widths).length > 0
        );
    }

    /**
     * Clear table container
     */
    clearTableContainer() {
        jQuery("#houses-table-container").empty().removeClass("loaded");
    }

    /**
     * Show loading indicator
     */
    showLoading() {
        const loading = document.getElementById("prices-page-overlay");
        if (loading) {
            loading.style.display = "flex";
        }
    }

    /**
     * Hide loading indicator
     */
    hideLoading() {
        const loading = document.getElementById("prices-page-overlay");
        if (loading) {
            loading.style.display = "none";
        }
    }

    /**
     * Smooth scroll to the table after loading
     */
    scrollToTable() {
        const tableContainer = document.getElementById("houses-table-container");
        if (!tableContainer) {
            return;
        }

        // Add a small delay to ensure the table is fully rendered
        setTimeout(() => {
            // Check if the table is already visible in the viewport
            const rect = tableContainer.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            // Only scroll if the table is not fully visible
            if (rect.top < 0 || rect.top > viewportHeight - 100) {
                tableContainer.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                });
            }
        }, 150);
    }
}

// Initialize when jQuery and DOM are ready
jQuery(document).ready(() => {
    new PricesPage();
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.page-template-prices").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".prices-page__filters .container",
            {
                duration: 1,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1,
            }
        );

        gsap.fromTo(
            ".prices-page .houses-table-empty",
            {
                duration: 1,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1.5,
            }
        );
    }
});

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Housing plans image switching functionality.
     * Switches corresponding images when housing plans tabs are clicked.
     */
    const housingPlansSection = document.querySelector(".housing-plans");

    // Function to show corresponding image based on tab
    function switchHousingPlanImage(activeTab, imageContainer) {
        const containerId = activeTab.getAttribute("data-container_id");

        // Extract the number from container ID (e.g., "container-1" -> "1")
        const containerNumber = containerId ? containerId.replace("container-", "") : null;

        if (containerNumber) {
            const planImages = imageContainer.querySelectorAll(".housing-plans__img");

            // Hide all images
            planImages.forEach((img) => {
                img.style.display = "none";
            });

            // Show the corresponding image
            const targetImage = imageContainer.querySelector(
                `[data-image_count="${containerNumber}"]`
            );
            if (targetImage) {
                targetImage.style.display = "block";
            }
        }
    }

    if (housingPlansSection) {
        const tabsContainer = housingPlansSection.querySelector(".tabs");
        const imageContainer = housingPlansSection.querySelector(".housing-plans__img-wrap");

        if (tabsContainer && imageContainer) {
            const tabItems = tabsContainer.querySelectorAll(".tabs__item");

            // Add click event listeners to tab items
            tabItems.forEach((tab) => {
                tab.addEventListener("click", function () {
                    // Use setTimeout to ensure the tab becomes active first
                    setTimeout(() => {
                        if (tab.classList.contains("tabs__item--active")) {
                            switchHousingPlanImage(tab, imageContainer);
                        }
                    }, 10);
                });
            });

            // Handle initial state - show image for active tab
            const activeTab = tabsContainer.querySelector(".tabs__item--active");
            if (activeTab) {
                switchHousingPlanImage(activeTab, imageContainer);
            }
        }
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.single-house").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".house__back, .house__status, .house__round, .house__title, .house__project-title, .house__address, .house__price, .stats__item, .house__cta-btn, .house__nav .container",
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                stagger: 0.2, // Автоматично додає затримку між елементами
                ease: "power2.out",
                delay: 0.5, // Загальна затримка перед початком анімації
            }
        );
    }
});

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Handle project address click to activate place tab and scroll to map.
     */
    const projectAddress = document.querySelector(".project__address");

    if (projectAddress) {
        projectAddress.addEventListener("click", function (e) {
            e.preventDefault();

            // Find the place tab
            const placeTab = document.querySelector("#place-tab");

            if (placeTab) {
                // Activate the place tab by triggering a click event
                placeTab.click();

                // Wait a bit for the tab content to be activated, then scroll
                setTimeout(() => {
                    const targetElement = document.querySelector(
                        projectAddress.getAttribute("href")
                    );
                    if (targetElement) {
                        targetElement.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }
                }, 100);
            }
        });
    }
});

/**
 * Add animation.
 */
jQuery(function ($) {
    if ($("body.single-project").length) {
        // Register ScrollTrigger plugin
        gsap.registerPlugin(ScrollTrigger);

        gsap.fromTo(
            ".project__title",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 0.5,
            }
        );

        gsap.fromTo(
            ".project__address",
            {
                duration: 1,
                y: 50,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                delay: 1,
            }
        );

        gsap.fromTo(
            ".project__nav .container",
            {
                duration: 1,
                opacity: 0,
                ease: "power2.out",
            },
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1.5,
            }
        );
    }
});

/**
 * Add animation.
 */

if (jQuery(".single-post").length) {
    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    jQuery(".post.type-post").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                delay: 1.5,
                ease: "power2.out",
            }
        );
    });

    jQuery(
        ".post__header h1, .post__header h2, .post__header h3, .post__header h4, .post__header h5, .post__header h6,  .post__header p, .post__content h1, .post__content h2, .post__content h3, .post__content h4, .post__content h5, .post__content h6, .post__content p, .property-gallery, .post__thumbnail"
    ).each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 1,
                ease: "linear",
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    });

    jQuery(".post__content li").each(function (index, element) {
        gsap.fromTo(
            element,
            {
                opacity: 0,
                y: 50,
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.7,
                delay: index * 0.1,
                ease: "linear",
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    });
}
